var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9974 29.8334H19.9974C26.6641 29.8334 29.3307 27.1667 29.3307 20.5V12.5C29.3307 5.83335 26.6641 3.16669 19.9974 3.16669H11.9974C5.33073 3.16669 2.66406 5.83335 2.66406 12.5V20.5C2.66406 27.1667 5.33073 29.8334 11.9974 29.8334Z",
    stroke: "#E6E9FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0026 13.8333C13.4754 13.8333 14.6693 12.6394 14.6693 11.1667C14.6693 9.69391 13.4754 8.5 12.0026 8.5C10.5298 8.5 9.33594 9.69391 9.33594 11.1667C9.33594 12.6394 10.5298 13.8333 12.0026 13.8333Z",
    stroke: "#E6E9FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5625 25.7666L10.1358 21.3533C11.1892 20.6466 12.7092 20.7266 13.6558 21.54L14.0958 21.9266C15.1358 22.82 16.8158 22.82 17.8558 21.9266L23.4025 17.1666C24.4425 16.2733 26.1225 16.2733 27.1625 17.1666L29.3358 19.0333",
    stroke: "#E6E9FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImg);
export default __webpack_public_path__ + "static/media/EmptyImg.8469fcb51944e06423f4b3410dfa94d1.svg";
export { ForwardRef as ReactComponent };